import { render } from "./SupervisorAssessementTab.vue?vue&type=template&id=dbb6ad7a"
import script from "./SupervisorAssessementTab.vue?vue&type=script&lang=js"
export * from "./SupervisorAssessementTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__